const { default: getFrontConfig } = require('../getFrontConfig');

const FRONT_CONFIG = getFrontConfig();
const { apiConfig } = FRONT_CONFIG;

/** Same function for backend in
 *  app_byl_core/cartridges/app_byl_core/cartridge/scripts/helpers/apiHelpers.js
 * Get the parameter value from request http parameters. You can pass a viewData
 * as fallback, to que the values from it.
 * It assures retrocompatibility: returns the paramName value if available,
 * otherwise the paramName of v0 if available.
 * @param {string} paramName - Parameter name
 * @param {Object} [options] - The object for additional data
 * @param {Object} [options.viewData] - The viewData object of the response
 * @returns {string|undefined} platform parameter value or undefined if not received
 */
function getParameterValueFromRequest(paramName, options) {
  const requestParameters = new URLSearchParams(window.location.search);
  const viewData = (options && options.viewData) || {};
  let param = requestParameters.get(paramName) || viewData[paramName];
  if (!param) {
    const oldParamName = apiConfig.parameterNameFromV0ParamMap[paramName];
    const paramV0 =
      requestParameters.get(oldParamName) || viewData[oldParamName];
    param =
      (apiConfig.paramFromV0ValueMap[paramName] &&
        apiConfig.paramFromV0ValueMap[paramName][paramV0]) ||
      apiConfig.DEFAULT_VALUE[paramName] ||
      paramV0;
  }
  return param;
}

/** Same function for backend in
 *  app_byl_core/cartridges/app_byl_core/cartridge/scripts/helpers/apiHelpers.js
 * Returns true if the platform belongs to web
 * @param {string} platform - platform value
 * @returns {boolean} True if platform belongs to web, false otherwise
 */
function isWebPlatform(platform) {
  return platform === apiConfig.platforms.WEB;
}

export { getParameterValueFromRequest, isWebPlatform };
